enum PendingTrayFileState {
  Uploaded = 'Uploaded',
  Recognized = 'Recognized',
  Pending = 'Pending',
  Splitted = 'Splitted',
  Archived = 'Archived',
}

export default PendingTrayFileState;
